import { assoc, curry, includes, isEmpty, pipe, mergeRight } from "ramda";
import { validateObject, validateField, isRequired } from "common/validation";

const contributorConstraints = fieldOptions => {
  let constraints = {
    role: {
      presence: {
        allowEmpty: false,
        message: "^validation_role_required",
      },
    },
    lastName: {
      presence: {
        allowEmpty: false,
        message: "^validation_lname_required",
      },
    },
  };

  if (isRequired("contributor_first_name", fieldOptions)) {
    constraints = mergeRight(constraints, {
      firstName: {
        presence: {
          allowEmpty: false,
          message: "^validation_fname_required",
        },
      },
    });
  }

  if (isRequired("contributor_middle_name", fieldOptions)) {
    constraints = mergeRight(constraints, {
      middleName: {
        presence: {
          allowEmpty: false,
          message: "^validation_mname_required",
        },
      },
    });
  }

  // let twitterConstraint = {
  //   format: {
  //     pattern: /^(@[A-Za-z0-9_]+)?$/,
  //     message: "^validation_twitter_invalid",
  //   },
  // };
  // if (isRequired("twitter_handle", fieldOptions)) {
  //   twitterConstraint = mergeRight(twitterConstraint, {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^validation_twitter_required",
  //     },
  //   });
  // }
  // constraints = mergeRight(constraints, {
  //   twitterHandle: twitterConstraint,
  // });

  let websiteConstraint = {
    format: {
      pattern: /^[^ "]*$/,
      message: "^validation_website_invalid",
    },
  };
  if (isRequired("website", fieldOptions)) {
    websiteConstraint = mergeRight(websiteConstraint, {
      presence: {
        allowEmpty: false,
        message: "^validation_website_required",
      },
    });
  }
  constraints = mergeRight(constraints, {
    website: websiteConstraint,
  });

  return constraints;
};

const corporationContributorConstraints = fieldOptions => {
  let constraints = {
    role: {
      presence: {
        allowEmpty: false,
        message: "^validation_role_required",
      },
    },
    corporationName: {
      presence: {
        allowEmpty: false,
        message: "^validation_corporation_required",
      },
    },
  };

  // let twitterConstraint = {
  //   format: {
  //     pattern: /^(@[A-Za-z0-9_]+)?$/,
  //     message: "^validation_twitter_invalid",
  //   },
  // };
  // if (isRequired("twitter_handle", fieldOptions)) {
  //   twitterConstraint = mergeRight(twitterConstraint, {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^validation_twitter_required",
  //     },
  //   });
  // }
  // constraints = mergeRight(constraints, {
  //   twitterHandle: twitterConstraint,
  // });

  let websiteConstraint = {
    format: {
      pattern: /^[^ "]*$/,
      message: "^validation_website_invalid",
    },
  };
  if (isRequired("website", fieldOptions)) {
    websiteConstraint = mergeRight(websiteConstraint, {
      presence: {
        allowEmpty: false,
        message: "^validation_website_required",
      },
    });
  }
  constraints = mergeRight(constraints, {
    website: websiteConstraint,
  });

  return constraints;
};

const baseConstraints = (collectFlags, fieldOptions) => {
  let constraints = {
    title: {
      presence: {
        allowEmpty: false,
        message: "^validation_title_required",
      },
    },
    description: {
      presence: {
        allowEmpty: false,
        message: "^validation_description_required",
      },
    },
  };

  const subtitleOptions = fieldOptions["subtitle"] || {};
  if (subtitleOptions.required) {
    console.log("Adding Subtitle Constraint!");
    constraints = mergeRight(constraints, {
      subtitle: {
        presence: {
          allowEmpty: false,
          message: "^validation_subtitle_required",
        },
      },
    });
  }

  const publicationYearOptions = fieldOptions["publication_year"] || {};
  if (collectFlags.collectPublicationYear || publicationYearOptions.required) {
    console.log("Adding Publication YEAR Constraint!");
    constraints = mergeRight(constraints, {
      publicationYear: {
        presence: {
          allowEmpty: false,
          message: "^validation_publication_year_required",
        },
        format: {
          pattern: /^[0-9]{4}$/,
          message: "^validation_publication_year_invalid",
        },
      },
    });
  }

  const publicationDateOptions = fieldOptions["publication_date"] || {};
  if (collectFlags.collectPublicationYear || publicationDateOptions.required) {
    console.log("Adding Publication DATE Constraint!");
    constraints = mergeRight(constraints, {
      publicationDate: {
        presence: {
          allowEmpty: false,
          message: "^validation_publication_date_required",
        },
        datetime: {
          message: "^validation_publication_date_invalid",
        },
      },
    });
  }

  const languageOptions = fieldOptions["language"] || {};
  if (languageOptions.required) {
    console.log("Adding Language Constraint!");
    constraints = mergeRight(constraints, {
      language: {
        presence: {
          allowEmpty: false,
          message: "^validation_language_required",
        },
      },
    });
  }

  const audienceOptions = fieldOptions["audience"] || {};
  if (audienceOptions.required) {
    console.log("Adding Audience Constraint!");
    constraints = mergeRight(constraints, {
      audience: {
        presence: {
          allowEmpty: false,
          message: "^validation_audience_required",
        },
      },
    });
  }
  console.log("Adding Keywords Constraint!");
  const keywordsOptions = fieldOptions["keywords"] || {};
  constraints = mergeRight(constraints, {
    keywords: {
      length: {
        maximum: 1000,
        message: "^validation_keywords_max_length",
      },
    },
  });
  if (keywordsOptions.required) {
    constraints = mergeRight(constraints, {
      keywords: {
        presence: {
          allowEmpty: false,
          message: "^validation_keywords_required",
        },
        length: {
          maximum: 1000,
        },
      },
    });
  }

  const purchaseUrlOptions = fieldOptions["purchase_url"] || {};
  if (purchaseUrlOptions.required) {
    console.log("Adding Purchase URL Constraint!");
    constraints = mergeRight(constraints, {
      keywords: {
        presence: {
          allowEmpty: false,
          message: "^validation_purchase_url_required",
        },
      },
    });
  }

  const subProjectsOptions = fieldOptions["sub_projects"] || {};
  if (subProjectsOptions.required) {
    console.log("Adding Sub Project Constraint!");
    constraints = mergeRight(constraints, {
      subProject: {
        presence: {
          allowEmpty: false,
          message: "^validation_sub_project_required",
          // message: `^Please select a value for ${fieldOptions["sub_projects"].fieldLabel}`,
        },
      },
    });
  }

  const customDropdownOptions = fieldOptions["custom_dropdown"] || {};
  if (customDropdownOptions.required) {
    console.log("Adding Custom Dropdown Constraint!");
    constraints = mergeRight(constraints, {
      customDropdown: {
        presence: {
          allowEmpty: false,
          message: "^validation_custom_dropdown_required",
          // message: `^Please select a value for ${fieldOptions["sub_projects"].fieldLabel}`,
        },
      },
    });
  }

  const customFreeformOptions = fieldOptions["custom_freeform"] || {};
  if (customFreeformOptions.required) {
    console.log("Adding Custom Freeform Constraint!");
    constraints = mergeRight(constraints, {
      customFreeform: {
        presence: {
          allowEmpty: false,
          message: "^validation_custom_freeform_required",
          // message: `^Please enter a value for ${fieldOptions["custom_freeform"].fieldLabel}`,
        },
      },
    });
  }

  const customFreeform2Options = fieldOptions["custom_freeform_2"] || {};
  if (customFreeform2Options.required) {
    console.log("Adding Custom Freeform 2 Constraint!");
    constraints = mergeRight(constraints, {
      customFreeform2: {
        presence: {
          allowEmpty: false,
          message: "^validation_custom_freeform_2_required",
          // message: `^Please enter a value for ${fieldOptions["custom_freeform"].fieldLabel}`,
        },
      },
    });
  }

  return constraints;
};

const albumConstraints = (collectFlags, fieldOptions) => {
  return baseConstraints(collectFlags, fieldOptions);
};

const audioConstraints = (collectFlags, fieldOptions) => {
  return baseConstraints(collectFlags, fieldOptions);
};

const bookConstraints = (collectFlags, fieldOptions) => {
  let constraints = baseConstraints(collectFlags, fieldOptions);

  let isbnConstraints = {
    length: value => {
      if (!value) return false;
      if (value.length === 10 || value.length === 13) return false;
      return { is: 10, message: "^validation_isbn_invalid" };
    },
    format: value =>
      value
        ? {
            pattern: "[0-9]+",
            message: "^validation_isbn_invalid_numbers_only",
          }
        : false,
  };

  if (isRequired("isbn", fieldOptions)) {
    isbnConstraints = mergeRight(isbnConstraints, {
      presence: {
        allowEmpty: false,
        message: "^validation_isbn_required",
      },
    });
  }

  constraints = mergeRight(constraints, {
    isbn: isbnConstraints,
    primaryCategory: {
      presence: {
        message: "^validation_primary_category_required",
      },
    },
  });

  if (isRequired("volume", fieldOptions)) {
    console.log("Adding Volume Constraint!");
    constraints = mergeRight(constraints, {
      volume: {
        presence: {
          allowEmpty: false,
          message: "^validation_volume_required",
        },
      },
    });
  }

  if (isRequired("edition", fieldOptions)) {
    console.log("Adding Edition Constraint!");
    constraints = mergeRight(constraints, {
      edition: {
        presence: {
          allowEmpty: false,
          message: "^validation_edition_required",
        },
      },
    });
  }

  console.log("Adding Primary Category Constraint!");
  constraints = mergeRight(constraints, {
    primaryCategory: {
      presence: {
        allowEmpty: false,
        message: "^validation_primary_category_required",
      },
    },
  });

  return constraints;
};

const imageConstraints = (collectFlags, fieldOptions) => {
  return baseConstraints(collectFlags, fieldOptions);
};

const documentConstraints = (collectFlags, fieldOptions) => {
  return baseConstraints(collectFlags, fieldOptions);
};

const videoConstraints = (collectFlags, fieldOptions) => {
  let constraints = baseConstraints(collectFlags, fieldOptions);

  if (isRequired("rating", fieldOptions)) {
    console.log("Adding Rating Constraint!");
    constraints = mergeRight(constraints, {
      rating: {
        presence: {
          allowEmpty: false,
          message: "^validation_rating_required",
        },
      },
    });
  }

  if (isRequired("series", fieldOptions)) {
    console.log("Adding Series Constraint!");
    constraints = mergeRight(constraints, {
      series: {
        presence: {
          allowEmpty: false,
          message: "^validation_series_required",
        },
      },
    });
  }

  if (isRequired("episode", fieldOptions)) {
    console.log("Adding Episode Constraint!");
    constraints = mergeRight(constraints, {
      episode: {
        presence: {
          allowEmpty: false,
          message: "^validation_episode_required",
        },
      },
    });
  }

  return constraints;
};

export const validateContributorField = (
  field,
  value,
  fieldOptions,
  errors = {},
) => validateField(contributorConstraints(fieldOptions), field, value, errors);

export const validateContributor = curry((fieldOptions, fields) =>
  fields.type === "PERSON"
    ? validateObject(contributorConstraints(fieldOptions), fields)
    : validateObject(corporationContributorConstraints(fieldOptions), fields),
);

const getConstraintsForContentType = (
  contentTypeName,
  collectFlags,
  fieldOptions,
) => {
  console.log("Getting Constraints...");
  console.log("Field Options: ", fieldOptions);

  switch (contentTypeName) {
    case "ALBUM":
      return albumConstraints(collectFlags, fieldOptions);
    case "AUDIO":
      return audioConstraints(collectFlags, fieldOptions);
    case "BOOK":
      return bookConstraints(collectFlags, fieldOptions);
    case "IMAGE":
      return imageConstraints(collectFlags, fieldOptions);
    case "OTHER_DOCUMENT":
      return documentConstraints(collectFlags, fieldOptions);
    case "VIDEO":
      return videoConstraints(collectFlags, fieldOptions);
    default:
      return {};
  }
};

export const validateDetailsField = curry(
  (workType, collectFlags, field, value, fieldOptions, errors) =>
    validateField(
      getConstraintsForContentType(
        workType.contentTypeName,
        collectFlags,
        fieldOptions,
      ),
      field,
      value,
      errors,
    ),
);

const contributorsRequired = (fieldOptions, contentType) => {
  if (fieldOptions.contributors) {
    return fieldOptions.contributors.required;
  } else {
    return includes(contentType, ["AUDIOBOOK", "BOOK"]);
  }
};

const validateContributors = curry(
  (contributors, fieldOptions, contentType, errors) => {
    if (isEmpty(contributors)) {
      if (contributorsRequired(fieldOptions, contentType)) {
        return assoc(
          "contributors",
          ["validation_contributors_required"],
          errors,
        );
      }
    }

    return errors;
  },
);

export const validateDetails = curry(
  (workType, contributors, collectFlags, fieldOptions, fields) =>
    pipe(
      validateObject(
        getConstraintsForContentType(
          workType.contentTypeName,
          collectFlags,
          fieldOptions,
        ),
      ),
      validateContributors(
        contributors,
        fieldOptions,
        workType.contentTypeName,
      ),
    )(fields),
);
